<script>
import { mapGetters } from 'vuex'
import { Helper, debounce } from '@/mixin/helper'
import Layout from '@/router/layouts/main'
import appConfig from '@/app.config'
import $store from '@/state/store'
import PageHeader from '@/components/page-header'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import MultiImeiModal from './Modal.vue'
import ConfirmationV2 from '@/components/widgets/modals/ConfirmationV2'
import McButton from '@/components/McButton'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Master Multi Imei',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    MultiImeiModal,
    ConfirmationV2,
    McButton,
  },

  mixins: [Helper],

  async created() {
    await this.fetchVehicles()
  },

  data() {
    return {
      selectedServerRegion: 'SG',
      vehicles: [],
      selected: {
        vehicle: [],
      },
      selectedModel: {
        vehicle: [],
      },
      allSelected: {
        vehicle: false,
      },
      indeterminate: {
        vehicle: true,
      },
      showModel: null,
      sortBy: 'license_plate',
      sortDesc: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filteredItems: [],
      filter: null,
      isLoading: false,
      showModal: false,
      selectedMultiImei: null,
      modalMode: null,
      showConfirmation: false,
      confirmationMessage: null,

      isLoadingDownload: false,
    }
  },

  computed: {
    title() {
      return this.$t('master.vehicle.multiImei.title')
    },

    visibleFields() {
      if (this.showModel && this.showModel.length > 0) {
        var result = this.showModel.map((a) => a.key)

        return this.vehicle.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.vehicle
      }
    },

    vehicle() {
      const columns = [
        {
          key: 'column_check',
          label: '',
          sortable: false,
        },
        {
          key: 'company',
          label: this.$t('master.multiImei.company'),
          sortable: true,
        },
        {
          key: 'license_plate',
          label: this.$t('master.multiImei.licensePlate'),
          sortable: true,
        },
        {
          key: 'parent_vehicle.vehicle_type_name',
          label: this.$t('master.multiImei.vehicleType'),
          sortable: false,
        },
        {
          key: 'parent',
          label: this.$t('master.multiImei.parent'),
          sortable: false,
        },
        {
          key: 'child',
          label: this.$t('master.multiImei.child'),
          sortable: false,
        },
        {
          key: 'sensor',
          label: this.$t('master.multiImei.sensor'),
          sortable: false,
        },
        {
          key: 'vehicle_group',
          label: this.$t('master.multiImei.vehicleGroup'),
          sortable: false,
        },
      ]

      return columns
    },

    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),

    flagSyncErp() {
      return $store.state.config.syncToERP
    },
  },

  methods: {
    openModal(mode, data) {
      this.showModal = true
      this.modalMode = mode
      this.selectedMultiImei = data
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.vehicles.length; i++) {
          this.selected[param].push(this.vehicles[i])
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.vehicles.length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        var myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    onDelete() {
      this.showConfirmation = true
      this.confirmationMessage = this.$t('master.multiImei.delete.message', {
        totalVehicle: this.selected.vehicle.length,
      })
    },

    async onConfirm() {
      this.isLoading = true

      // Kumpulkan semua id
      const childIds = this.selected.vehicle.map((v) => v.vehicle_id)

      // Kirim sekali request dengan body array
      const response = await vehicleApi.unassignVehicleChild(
        {
          child_vehicle_ids: childIds,
        },
        this.selectedServerRegion
      )

      if (response?.status === 200) {
        this.$toast.success(`Data ${childIds.length} kendaraan Multi IMEI berhasil dihapus`)
      }
      this.fetchVehicles()
      this.clearDelete()
    },

    clearDelete() {
      this.allSelected.vehicle = false
      this.selectedModel.vehicle = []
      this.selected.vehicle = []
    },

    cancel() {
      this.resetModal()
    },

    resetModal() {
      this.isChanging = false
      this.isChangingDevice = false
      this.isChangingSimCard = false
      this.isMirroring = false
      this.vehicle = null
      this.optionProcess = null
      this.set = {
        companies: null,
        identifier: null,
        deviceName: null,
        imei: null,
        vendorType: null,
        phoneNo: null,
        vehicleId: null,
        newImei: null,
      }
    },

    async fetchVehicles() {
      this.isLoading = true
      let payload = {
        filters: ['parent_vehicle_id is not null'],
        page: this.currentPage,
        limit: this.perPage,
      }

      if (this.filter) {
        payload["search"] = this.filter
      }

      const vehicleList = await vehicleApi.get(payload, this.selectedServerRegion)
      if (!vehicleList?.data) {
        this.filteredItems = []
        this.totalRows = 0
        this.currentPage = 1
        this.perPage = 10
        this.totalPages = 1
        this.vehicles = []
        this.isLoading = false
        return
      }

      this.vehicles = vehicleList.data.paginated_result
      this.filteredItems = vehicleList.data.paginated_result
      this.totalRows = vehicleList.metadata.total_count
      this.currentPage = Number(vehicleList.metadata.page || 1)
      if (this.currentPage < 1) this.currentPage = 1
      this.totalPages = vehicleList.metadata.total_page
      this.isLoading = false
    },

    changePage(e) {
      this.currentPage = e
      this.fetchVehicles()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.fetchVehicles()
    },

    searchData: debounce(function () {
      this.currentPage = 1
      this.perPage = 10
      this.fetchVehicles()
    }, 600),

    async onServerRegionChange() {
      this.currentPage = 1
      this.perPage = 10
      await this.fetchVehicles()
    },

    async onSaved() {
      this.showModal = false
      await this.fetchVehicles()
    },

    async onDownload() {
      this.isLoadingDownload = true
      let params = {
        filters: ['parent_vehicle_id is not null'],
        page: this.currentPage,
        limit: this.perPage,
      }
      if (this.filter) {
        params.filters.push(`parent_license_plate eq ${this.filter}`)
      }
      const response = await vehicleApi.downloadMultiImei(params, this.selectedServerRegion)

      const url = window.URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'Multi IMEI.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      this.isLoadingDownload = false
      return
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <p class="mb-4">{{ $t('master.multiImei.description') }}</p>

    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="$router.back()"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
        <b-button
          v-if="hasAccessAll(['sms-device-multi-imei:delete'])"
          @click="onDelete"
          :variant="selected.vehicle.length > 0 ? 'outline-danger' : 'outline-secondary'"
          menu-class="dropdown-menu-end"
          class="ms-3 mc-multi-imei__delete-btn"
          :disabled="!(selected.vehicle.length > 0) || isLoading || isLoadingDownload"
        >
          <i class="bx bx-trash-alt" /> {{ $t('global.delete') }}
        </b-button>
        <b-button
          v-if="hasAccessAll(['sms-device-multi-imei:create'])"
          @click="openModal('add', null)"
          variant="primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
          :disabled="isLoading || isLoadingDownload"
        >
          <b-spinner v-if="isLoading" small />
          <i v-else class="mc-fa icon-outline_plus text-danger" />
          {{ $t('master.multiImei.button.add') }}
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-start me-3 d-flex align-items-center">
                <b-form-select
                  class="form-select form-select-md __limit--dropdown"
                  v-model="selectedServerRegion"
                  @change="onServerRegionChange"
                  :disabled="isLoading || isLoadingDownload"
                >
                  <b-form-select-option value="SG">
                    {{ $t('global.serverRegion.singapore') }}
                  </b-form-select-option>
                  <b-form-select-option value="ID">
                    {{ $t('global.serverRegion.indonesia') }}
                  </b-form-select-option>
                </b-form-select>
              </div>

              <div class="float-start">
                <h6 v-if="selected.vehicle.length" class="mc-row-check">
                  <span class="badge btn-success">{{ selected.vehicle.length }}</span>
                  Baris terpilih.
                  <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
                </h6>
              </div>

              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <McButton
                      variant="secondary"
                      :text="$t('master.multiImei.download')"
                      icon="icon-outline_download"
                      @click="onDownload"
                      class="d-inline-flex"
                      :disabled="isLoading || isLoadingDownload"
                    >
                      <b-spinner v-if="isLoadingDownload" small />
                    </McButton>
                    <McButton
                      variant="secondary"
                      :text="$t('master.multiImei.upload')"
                      icon="icon-outline_upload"
                      @click="$router.push({ name: 'Multi IMEI Import' })"
                      class="d-inline-flex ms-3"
                      :disabled="isLoading || isLoadingDownload"
                    />
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2"
                        @input="searchData"
                        :disabled="isLoading || isLoadingDownload"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table Tracking -->
            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="vehicles"
                :fields="visibleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="isLoading"
                @hidden="resetModal"
                stickyHeader
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #head(column_check)>
                  <div class="form-check">
                    <b-form-checkbox
                      @change="toggleAll($event, 'vehicle')"
                      v-model="allSelected.vehicle"
                      :indeterminate="indeterminate.vehicle"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!hasAccessAll(['sms-device-multi-imei:delete']) || isLoading"
                    />
                  </div>
                </template>

                <template #cell(column_check)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data.item, 'vehicle')"
                      v-model="selectedModel.vehicle[data.index]"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!hasAccessAll(['sms-device-multi-imei:delete'])"
                    />
                  </div>
                </template>
                <template #cell(license_plate)="data">
                  {{ data.item.parent_vehicle.license_plate }}
                </template>
                <template #cell(company)="data">
                  {{
                    `${data.item.parent_vehicle.company_name} (${data.item.parent_vehicle.domain_name})`
                  }}
                </template>
                <template #cell(parent)="data">
                  <strong
                    class="text-primary cursor-pointer"
                    v-if="hasAccessAll(['sms-device-multi-imei:update'])"
                    @click="openModal('edit-parent', data.item)"
                  >
                    {{
                      `${data.item.parent_vehicle.device_category} • ${data.item.parent_vehicle.imei}`
                    }}
                  </strong>
                  <span v-else>
                    {{
                      `${data.item.parent_vehicle.device_category} • ${data.item.parent_vehicle.imei}`
                    }}
                  </span>
                </template>

                <template #cell(child)="data">
                  <strong
                    class="text-primary cursor-pointer"
                    v-if="hasAccessAll(['sms-device-multi-imei:update'])"
                    @click="openModal('edit-child', data.item)"
                  >
                    {{ `${data.item.device_category} • ${data.item.imei}` }}
                  </strong>
                  <span v-else>
                    {{ `${data.item.device_category} • ${data.item.imei}` }}
                  </span>
                </template>
                <template #cell(sensor)="data">
                  {{
                    Array.from(
                      new Set([
                        ...(data.item.parent_vehicle?.sensors?.map((s) => s.sensor_name) || []),
                        ...(data.item.sensors?.map((s) => s.sensor_name) || []),
                      ])
                    ).join(', ')
                  }}
                </template>
                <template #cell(vehicle_group)="data">
                  {{
                    (data.item.parent_vehicle?.vgroup_names?.length ===
                      data.item.vgroup_names?.length &&
                    data.item.parent_vehicle?.vgroup_names?.every(
                      (v, i) => v === data.item.vgroup_names[i]
                    )
                      ? data.item.vgroup_names
                      : Array.from(
                          new Set([
                            ...(data.item.parent_vehicle?.vgroup_names || []),
                            ...(data.item.vgroup_names || []),
                          ])
                        )
                    ).join(', ')
                  }}
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                        :disabled="isLoading || isLoadingDownload"
                      />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span
                      >Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                      :disabled="isLoading || isLoadingDownload"
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal multi imei-->
    <MultiImeiModal
      v-model="showModal"
      :mode="modalMode"
      :data="selectedMultiImei"
      :serverRegion="selectedServerRegion"
      @saved="onSaved"
    />

    <ConfirmationV2
      v-if="showConfirmation"
      :modal.sync="showConfirmation"
      :message="confirmationMessage"
      :okTitle="$t('master.multiImei.delete.confirmation')"
      @confirmed="onConfirm"
    />
  </Layout>
</template>
